module.exports = __webpack_public_path__ + "477804cc3027ed6732c0034bea950425.png";